import type { TooltipModel } from 'chart.js';

export interface TooltipLine {
  label: string;
  value: string;
  color: string;
}

export interface TooltipPoint {
  x: number;
  y: number;
  title: string;
  lines: TooltipLine[];
}

/**
 * Traduce el `TooltipModel` que Chart.js entrega al callback `external` en los
 * datos que necesita el overlay HTML de RadarChart. Se usa `external` en vez
 * del tooltip nativo porque este se dibuja dentro del propio `<canvas>` y por
 * lo tanto siempre queda detrás de los iconos superpuestos (una capa HTML
 * aparte, con mayor z-index) — un tooltip HTML sí puede apilarse por encima.
 */
export function buildTooltipPoint(tooltip: TooltipModel<'radar'>): TooltipPoint | null {
  if (tooltip.opacity === 0 || tooltip.dataPoints.length === 0) {
    return null;
  }
  const lines = tooltip.dataPoints.map(point => ({
    label: point.dataset.label ?? '',
    value: String(point.formattedValue),
    color: typeof point.dataset.borderColor === 'string' ? point.dataset.borderColor : '#000',
  }));
  return {
    x: tooltip.caretX,
    y: tooltip.caretY,
    title: tooltip.title[0] ?? '',
    lines,
  };
}
